module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ddf1e5c0c982e9536d539fbf8e2c738f.png";